import React from 'react';
export const NotificationsContext = React.createContext(null);
//# sourceMappingURL=notifications.context.js.map